export default __webpack_public_path__ + "media/changemakers.fc2184634cc63aa0061b109e5e260ad4.svg";